/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_See_All_ChatsInputs */



/**
* | output |
* | --- |
* | "Can see everyone's chats" |
*
* @param {Audit_Details_See_All_ChatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_see_all_chats = /** @type {((inputs?: Audit_Details_See_All_ChatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_See_All_ChatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Darf die Chats aller Mitglieder sehen")
	return /** @type {LocalizedString} */ ("Can see everyone's chats")
});